const iconClass = 'h-10 w-10';

export function PhysicsIcon() {
  return (
    <svg className={iconClass} viewBox="0 0 40 40" fill="none" aria-hidden>
      <circle cx="20" cy="20" r="6" stroke="#22c55e" strokeWidth="2" />
      <ellipse cx="20" cy="20" rx="16" ry="6" stroke="#22c55e" strokeWidth="2" />
      <ellipse cx="20" cy="20" rx="6" ry="16" stroke="#22c55e" strokeWidth="2" transform="rotate(60 20 20)" />
    </svg>
    
  );
}

export function ChemistryIcon() {
  return (
    <svg className={iconClass} viewBox="0 0 40 40" fill="none" aria-hidden>
      <path d="M14 8h12v6l-6 20-6-20V8z" stroke="#14b8a6" strokeWidth="2" strokeLinejoin="round" />
      <path d="M12 14h16" stroke="#14b8a6" strokeWidth="2" />
      <circle cx="20" cy="26" r="3" fill="#14b8a6" />
    </svg>
  );
}

export function MathIcon() {
  return (
    <svg className={iconClass} viewBox="0 0 40 40" fill="none" aria-hidden>
      <text x="6" y="26" fill="#22c55e" fontSize="14" fontWeight="600" fontFamily="Inter, sans-serif">
        (x+y)
      </text>
    </svg>
  );
}

export function BiologyIcon() {
  return (
    <svg className={iconClass} viewBox="0 0 40 40" fill="none" aria-hidden>
      <path d="M12 28c0-8 4-14 8-14s8 6 8 14" stroke="#0ea5e9" strokeWidth="2" />
      <path d="M20 14V8M16 10l4-4 4 4" stroke="#0ea5e9" strokeWidth="2" strokeLinecap="round" />
      <rect x="10" y="26" width="20" height="6" rx="2" stroke="#0ea5e9" strokeWidth="2" />
    </svg>
  );
}

const ICON_MAP = {
  physics: PhysicsIcon,
  chemistry: ChemistryIcon,
  math: MathIcon,
  biology: BiologyIcon,
};

export function CategoryIcon({ type }) {
  const Icon = ICON_MAP[type] || PhysicsIcon;
  return <Icon />;
}
